import React from 'react'
import styles from './styles.module.css'

const AuthHeaderDynamicMenuItem = ({ title, icon, route, tabIndex }) => (
  <a href={route} target="_blank" rel="noopener noreferrer">
    <hot-dropdown-menu-item slot="menu" class={`${styles.headerToolsItem}`} tabIndex={tabIndex}>
      <span className="_p-4 _rounded-lg _mb-1 blue">{icon}</span>
      <span className="_flex-1">{title}</span>
    </hot-dropdown-menu-item>
  </a>
)

export default AuthHeaderDynamicMenuItem
